import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Text } from '@/Components/Preferences/PreferencesComponents/Content';
import { useApplication } from '@/Components/ApplicationProvider';
import { formatDefaultDateTime } from '@/Utils/LocalizedDateFormat';
import { AppName } from '@standardnotes/features';
import { c } from 'ttag';
const SubscriptionStatusText = () => {
    const application = useApplication();
    const { userSubscriptionName, userSubscriptionExpirationDate, isUserSubscriptionExpired, isUserSubscriptionCanceled, } = application.subscriptions;
    const isSharedSubscription = application.subscriptionController.isSharedSubscription;
    const expirationDateString = userSubscriptionExpirationDate
        ? formatDefaultDateTime(userSubscriptionExpirationDate)
        : undefined;
    const appNameBold = _jsx("span", { className: "font-bold", children: AppName });
    const subscriptionTierBold = userSubscriptionName ? _jsxs("span", { className: "font-bold", children: [" ", userSubscriptionName] }) : null;
    const expirationDateBold = _jsx("span", { className: "font-bold", children: expirationDateString });
    const sharedMessage = isSharedSubscription ? (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("br", {}), c('B6.Preferences.Subscription.Info')
                .t `This subscription has been shared with you and can only be managed by the owner.`] })) : null;
    if (isUserSubscriptionCanceled) {
        return (_jsxs(Text, { className: "mt-1", children: [isUserSubscriptionExpired
                    ? c('B6.Preferences.Subscription.Info')
                        .jt `Your ${appNameBold}${subscriptionTierBold} subscription has been canceled and expired on ${expirationDateBold}. You may resubscribe below if you wish.`
                    : c('B6.Preferences.Subscription.Info')
                        .jt `Your ${appNameBold}${subscriptionTierBold} subscription has been canceled but will remain valid until ${expirationDateBold}. You may resubscribe below if you wish.`, sharedMessage] }));
    }
    if (isUserSubscriptionExpired) {
        return (_jsxs(Text, { className: "mt-1", children: [c('B6.Preferences.Subscription.Info')
                    .jt `Your ${appNameBold}${subscriptionTierBold} subscription expired on ${expirationDateBold}. You may resubscribe below if you wish.`, sharedMessage] }));
    }
    return (_jsxs(Text, { className: "mt-1", children: [c('B6.Preferences.Subscription.Info')
                .jt `Your ${appNameBold}${subscriptionTierBold} subscription will be renewed on ${expirationDateBold}.`, sharedMessage] }));
};
export default observer(SubscriptionStatusText);
